import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useTheme } from '../ThemeContext';

export default function SectionHeader({ number, title, mb = 'mb-12' }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });
  const { isCyberpunk } = useTheme();

  return (
    <div ref={ref} className={`flex items-center gap-4 ${mb}`}>
      <motion.span
        initial={{ opacity: 0, x: -20 }}
        animate={isInView ? { opacity: 1, x: 0 } : {}}
        transition={{ duration: 0.5 }}
        className={`font-mono text-lg transition-colors duration-500 ${
          isCyberpunk ? 'text-cyber-magenta' : 'text-indigo-500'
        }`}
      >
        {number}
      </motion.span>

      <h2
        className={`font-display text-3xl sm:text-4xl font-bold tracking-wider transition-colors duration-500 ${
          isCyberpunk ? 'text-white' : 'text-gray-900'
        }`}
        style={{ perspective: '600px' }}
      >
        {title.split('').map((char, i) => (
          <motion.span
            key={i}
            style={{ display: 'inline-block' }}
            initial={{ opacity: 0, y: 30, rotateX: 90 }}
            animate={isInView ? { opacity: 1, y: 0, rotateX: 0 } : {}}
            transition={{ duration: 0.4, delay: 0.15 + i * 0.04, ease: 'easeOut' }}
          >
            {char === ' ' ? ' ' : char}
          </motion.span>
        ))}
      </h2>

      <motion.div
        initial={{ scaleX: 0, opacity: 0 }}
        animate={isInView ? { scaleX: 1, opacity: 1 } : {}}
        transition={{ duration: 0.8, delay: 0.15 + title.length * 0.04 + 0.1, ease: 'easeOut' }}
        style={{ originX: 0 }}
        className={`flex-1 h-[1px] ml-4 ${
          isCyberpunk
            ? 'bg-gradient-to-r from-cyber-magenta/40 to-transparent'
            : 'bg-gradient-to-r from-gray-300 to-transparent'
        }`}
      />
    </div>
  );
}
